import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as types from '../../../../constants/actionTypes';
import Drawer from '../../../Common/Drawer/Drawer';
import Notification from '../../../Common/Notification';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';
import { actions as projectLocationActions } from '../../../../actions/projectLocationActions';

export class ChangeProjectManagerDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			selectedManagerId: '',
			isFormValid: true,
		};
	}

	onSave = async () => {
		if (this.state.selectedManagerId) {
			try {
				const response = await this.props.projectLocationActions.updateProjectManager(
					this.props.selectedProjectLocations.map((m) => m.id),
					this.state.selectedManagerId,
					this.props.projectKey
				);
				if (response.type === types.UPDATE_PROJECTLOCATION_MANAGER_SUCCESS) {
					const payload = response.payload;

					// show warning message oncomplete if some locations have not been pushed
					Notification('success', 'Success', 'Project Manager updated successfully');
					this.props.onComplete(payload.skippedSomeLocations);
				} else if (response.type === types.UPDATE_PROJECTLOCATION_MANAGER_FAILURE) {
					Notification('error', 'An Error Occurred', response.payload.message);
					this.setState({ isLoading: false });
				}
			} catch (error) {
				Notification('error', 'Error', error);
			}
		} else {
			this.setState({ isFormValid: false });
		}
	};

	onChangeManager = (id) => {
		this.setState({ selectedManagerId: id });
	};

	render() {
		return (
			<div>
				<LoadingIndicator isLoading={this.props.isLoading}>
					<Drawer
						isWide={false}
						title='Change Project Manager'
						onSaveClick={this.onSave}
						saveText='Save'
						onCancelClick={this.props.onCancel}>
						<form noValidate className={this.state.isFormValid ? '' : 'was-validated'}>
							<MultiSelectBox
								name='projectManager'
								label='Project Manager'
								idField='id'
								valueField='name'
								options={this.props.projectManagers}
								selectedValues={this.state.selectedManagerId.toString()}
								onChange={this.onChangeManager}
								isRequired={true}
								errorMessage='Required'
								isMulti={false}
							/>
						</form>
					</Drawer>
				</LoadingIndicator>
			</div>
		);
	}
}

ChangeProjectManagerDrawer.propTypes = {
	projectLocationActions: PropTypes.object.isRequired,
	projectManagers: PropTypes.array.isRequired,
	selectedProjectLocations: PropTypes.array.isRequired,
	projectKey: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch) => {
	return {
		projectLocationActions: bindActionCreators(projectLocationActions, dispatch),
	};
};

export default connect(null, mapDispatchToProps)(ChangeProjectManagerDrawer);
